module.exports = __webpack_public_path__ + "img/logo-xbox-one.b10b97e3.svg";